import { render, staticRenderFns } from "./OrderDeadLineTimer.vue?vue&type=template&id=bb8941fc&scoped=true&"
import script from "./OrderDeadLineTimer.vue?vue&type=script&lang=js&"
export * from "./OrderDeadLineTimer.vue?vue&type=script&lang=js&"
import style0 from "./OrderDeadLineTimer.vue?vue&type=style&index=0&id=bb8941fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8941fc",
  null
  
)

export default component.exports